import React, {useContext, useEffect, useState} from "react";
import setBusiness from "assets/Login/setBusiness.png";
import legal_stuff from "assets/Login/legal-stuff.png";
import link_bank from "assets/Login/signup-otp.png";
import map_img from "assets/Login/map-img.png";
import branding_img from "assets/Login/branding-img.png";
import Button from "components/molecules/Button";
import {useForm} from "components/molecules/Form";
import {RiArrowLeftSLine} from "react-icons/ri";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {useNavigate} from "react-router-dom";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import authService from "services/authService";
import Toast from "components/molecules/Toast";
import BusinessDetails from "components/atoms/BusinessSetup/BusinessDetails";
import LegalStuff from "components/atoms/BusinessSetup/LegalStuff";
import BankInfo from "components/atoms/BusinessSetup/BankInfo";
import {AuthContext, useAuthContext} from "Context/authContext";
import manageStores from "services/manageSores";
import BusinessMap from "components/atoms/BusinessSetup/BusinessMap";
import BusinessBranding from "components/atoms/BusinessSetup/BusinessBranding";
import {useSelector} from "react-redux";

const BusinessSetup = () => {
    const {user, refetch} = useAuthContext();
    const [form] = useForm();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {},
    });
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState({
        page: 1,
        pageSize: 10,
        searchText: "",
        startDate: "",
        endDate: "",
        getAll: true,
    });
    const {businessSetup2} = useSelector(state => state.business);

    const {cuisine_data, cuisine_loading} = manageStores.GetCuisines(searchQuery, fetch);

    const totalSteps = 5;
    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(prevStep => prevStep - 1);
        }
    };
    const stepImages = [setBusiness, map_img, branding_img, legal_stuff, link_bank];

    async function handleSubmit(e, cuisineData) {
        if (currentStep === 5) {
            // Use cuisine_data passed from BankInfo component if available, otherwise use the one from state
            const cuisineDataToUse = cuisineData || cuisine_data;

            const stepFive = {
                bank_name: typeof e.bank_name === "object" ? e.bank_name?.value || "" : e.bank_name || "",
                account_no: e.account_no || "",
                account_title: e.account_title || "", // Make sure account_title is properly set
                transit_number: e.transit_number || "",
                bank_code: e.bank_code || "",
                iban: e.account_no || "", // Using account_no as iban since it's required by backend
            };

            const requiredBankFields = ["bank_name", "account_no", "account_title", "iban"];
            let missingBankFields = requiredBankFields.filter(field => !stepFive[field]);

            if (missingBankFields.length > 0) {
                console.warn("Missing required bank fields in form submission:", missingBankFields);
                Toast({
                    type: "error",
                    message: `Please fill in all required bank details: ${missingBankFields.join(", ")}`,
                });
                return; // Prevent form submission if required fields are missing
            }

            setFormData(prev => ({...prev, step5: {...stepFive}}));
            const addressData = formData.step2?.address || {};
            const validatedAddress = {
                street_address: addressData.street_address || "",
                city: addressData.city || "",
                state: addressData.state || "",
                country: addressData.country || "",
                postal_code: addressData.postal_code || "",
                latlng: {
                    lat: addressData.latlng?.lat || 37.7749,
                    lng: addressData.latlng?.lng || -122.4194,
                },
            };

            // Get cuisines from step1 if available, otherwise use categories
            const cuisinesFromStep1 = formData.step1.cuisines || formData.step1.categories;

            const businessData = {
                ...formData.step1,
                address: validatedAddress,
                // Ensure categories is properly set and not null
                categories:
                    formData.step1.categories && formData.step1.categories.length > 0
                        ? formData.step1.categories.filter(cat => cat !== null)
                        : ["Fast Food"], // Default category if none selected
                cuisines: [], // We'll populate this with proper ObjectIds below
            };
            businessData.cuisines = [];
            // If we have cuisine data from the API, use those IDs
            if (cuisineDataToUse && cuisineDataToUse.cuisines && Array.isArray(cuisineDataToUse.cuisines)) {
                console.log(
                    "Available cuisine data:",
                    cuisineDataToUse.cuisines.map(c => ({name: c.name, id: c._id}))
                );

                // If cuisinesFromStep1 contains cuisine names, map them to their corresponding IDs
                if (cuisinesFromStep1 && Array.isArray(cuisinesFromStep1) && cuisinesFromStep1.length > 0) {
                    const validCuisines = cuisinesFromStep1.filter(cat => cat !== null && cat !== undefined);
                    console.log("Valid cuisines to map:", validCuisines);

                    if (validCuisines.length > 0) {
                        // Try to match cuisine names with IDs from cuisineDataToUse
                        const cuisineIds = validCuisines
                            .map(cuisineName => {
                                // Find matching cuisine in cuisineDataToUse
                                const matchedCuisine = cuisineDataToUse.cuisines.find(
                                    c => c.name && String(c.name).toLowerCase() === String(cuisineName).toLowerCase()
                                );

                                console.log(
                                    `Matching cuisine '${cuisineName}':`,
                                    matchedCuisine ? matchedCuisine._id : "No match found"
                                );
                                return matchedCuisine && matchedCuisine._id ? matchedCuisine._id : null;
                            })
                            .filter(id => id !== null);

                        if (cuisineIds.length > 0) {
                            businessData.cuisines = cuisineIds;
                            console.log("Mapped cuisine IDs:", cuisineIds);
                        }
                    }
                }
            }

            // If no valid cuisine IDs were found, use default cuisine ID if available
            if (!businessData.cuisines || !Array.isArray(businessData.cuisines) || businessData.cuisines.length === 0) {
                console.log("No valid cuisine IDs found, using default");

                // Try to find a default cuisine ID from cuisineDataToUse
                if (cuisineDataToUse && cuisineDataToUse.cuisines && Array.isArray(cuisineDataToUse.cuisines)) {
                    const defaultCuisine = cuisineDataToUse.cuisines.find(
                        c => c.name && String(c.name).toLowerCase() === "fast food"
                    );

                    if (defaultCuisine && defaultCuisine._id) {
                        businessData.cuisines = [defaultCuisine._id];
                        console.log("Using default cuisine ID:", defaultCuisine._id);
                    } else {
                        if (cuisineDataToUse.cuisines.length > 0 && cuisineDataToUse.cuisines[0]._id) {
                            businessData.cuisines = [cuisineDataToUse.cuisines[0]._id];
                            console.log("Using first available cuisine ID:", cuisineDataToUse.cuisines[0]._id);
                        } else {
                            businessData.cuisines = [];
                            console.log("No cuisine IDs available, sending empty array");
                        }
                    }
                } else {
                    businessData.cuisines = [];
                    console.log("No cuisine data available, sending empty array");
                }
            }

            const bank_tax_Details = {
                ...formData.step4,
                ...stepFive,
            };

            if (typeof bank_tax_Details.bank_name === "object" && bank_tax_Details.bank_name !== null) {
                bank_tax_Details.bank_name = bank_tax_Details.bank_name.value || "";
            }

            requiredBankFields.forEach(field => {
                if (!bank_tax_Details[field]) {
                    bank_tax_Details[field] = field === "bank_name" ? "Default Bank" : "";
                }
            });

            const requiredAddressFields = ["street_address", "city", "state", "postal_code", "latlng"];
            const missingAddressFields = requiredAddressFields.filter(field => {
                if (field === "latlng") {
                    return (
                        !businessData.address.latlng ||
                        businessData.address.latlng.lat === undefined ||
                        businessData.address.latlng.lng === undefined
                    );
                }
                return !businessData.address[field];
            });

            if (missingAddressFields.length > 0) {
                console.warn("Missing required address fields:", missingAddressFields);
            }
            missingBankFields = requiredBankFields.filter(field => {
                return !bank_tax_Details[field];
            });

            if (!businessData.cuisines || !Array.isArray(businessData.cuisines)) {
                businessData.cuisines = [];
            }

            if (Array.isArray(businessData.cuisines)) {
                businessData.cuisines = businessData.cuisines
                    .map(id => {
                        if (typeof id === "object" && id !== null && id._id) {
                            return id._id;
                        }
                        return id;
                    })
                    .filter(id => id !== null && id !== undefined);
            }

            const formDataToSend = new FormData();
            const businessDataString = JSON.stringify(businessData);

            formDataToSend.append("businessData", businessDataString);
            formDataToSend.append("bank_tax_Details", JSON.stringify(bank_tax_Details));
            if (formData?.logo) {
                formDataToSend.append("logo", formData.logo);
            }
            if (formData?.banner) {
                formDataToSend.append("cover_banner", formData.banner);
            }

            try {
                setLoading(true);
                const res = await authService.completeProfile(formDataToSend);
                refetch();
                navigate("/pricing");
                setLoading(false);
                Toast({type: "success", message: res.message});
            } catch (err) {
                setLoading(false);
                Toast({type: "error", message: err.message});
            }
        }
    }


    return (
        <>
            <OnBoardingLayout img={stepImages[currentStep - 1]}>
                <BusinnesWrap>
                    <div className="stepper-container">
                        {currentStep > 1 && (
                            <Button
                                width="87px"
                                className="btn"
                                variant="white"
                                gap="1px !important"
                                onClick={prevStep}
                                disabled={currentStep === 1}>
                                <RiArrowLeftSLine />
                                Back
                            </Button>
                        )}
                        {/* {currentStep === 1 && (
                            <Button
                                width="87px"
                                className="btn"
                                variant="white"
                                gap="1px !important"
                                onClick={() => navigate("/signup")}>
                                <RiArrowLeftSLine />
                                Back
                            </Button>
                        )} */}
                        {/* <div className="stepper">
                            {[...Array(totalSteps)].map((_, index) => (
                                <div
                                    key={index}
                                    className={`step ${index + 1 <= currentStep ? "active" : ""} ${
                                        index + 1 < currentStep ? "current" : ""
                                    } `}>
                                    {index + 1 < currentStep ? <span>&#10003;</span> : <span>{index + 1}</span>}
                                </div>
                            ))}
                        </div> */}

                        <div className="content">
                            {currentStep === 1 && (
                                <BusinessDetails
                                    setFormData={setFormData}
                                    setCurrentStep={setCurrentStep}
                                    prevData={formData.step1}
                                    logo={formData?.logo}
                                    currentStep={currentStep}
                                    totalSteps={totalSteps}
                                    cuisine_data={cuisine_data}
                                />
                            )}
                            {currentStep === 2 && (
                                <BusinessMap
                                    setFormData={setFormData}
                                    prevData={formData.step2}
                                    setCurrentStep={setCurrentStep}
                                    currentStep={currentStep}
                                    totalSteps={totalSteps}
                                />
                            )}
                            {currentStep === 3 && (
                                <BusinessBranding
                                    setFormData={setFormData}
                                    prevData={formData.step5}
                                    setCurrentStep={setCurrentStep}
                                    currentStep={currentStep}
                                    totalSteps={totalSteps}
                                    formData={formData}
                                />
                            )}
                            {currentStep === 4 && (
                                <LegalStuff
                                    setFormData={setFormData}
                                    prevData={formData.step5}
                                    setCurrentStep={setCurrentStep}
                                    currentStep={currentStep}
                                    totalSteps={totalSteps}
                                />
                            )}

                            {currentStep === 5 && (
                                <BankInfo handleSubmit={handleSubmit} loading={loading} cuisine_data={cuisine_data} />
                            )}
                        </div>
                    </div>
                </BusinnesWrap>
            </OnBoardingLayout>
        </>
    );
};

export default BusinessSetup;
